// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'align-item-up-solid';

export const Component = () => (
  <path d='M13.787 17.188V5.405c0-.431.143-.766.431-1.054.239-.287.575-.43 1.005-.43h3.928c.431 0 .766.143 1.054.43.287.288.43.623.43 1.054v11.782c0 .43-.143.766-.43 1.053a1.408 1.408 0 0 1-1.054.432h-3.928c-.43 0-.766-.144-1.005-.432a1.408 1.408 0 0 1-.431-1.053Zm-8.334 7.328H9.38c.432 0 .767-.144 1.054-.432.24-.239.383-.575.383-1.005V5.406a1.58 1.58 0 0 0-.383-1.054 1.408 1.408 0 0 0-1.054-.43H5.453a1.41 1.41 0 0 0-1.054.43 1.408 1.408 0 0 0-.431 1.054V23.08c0 .431.144.766.431 1.005.288.288.623.432 1.054.432ZM23.078 1H1.527C1.19 1 1 1.144 1 1.479c0 .335.191.479.527.479h21.551c.335 0 .527-.144.527-.48 0-.334-.192-.478-.527-.478Z' />
);

export const viewBox = '0 0 25 25';
